module.exports = __webpack_public_path__ + "assets/media/lunch.f29e6ed9.mp3";